import React from 'react';
import { Layout, Menu } from 'antd';
import { Link, Outlet } from 'react-router-dom';
import './EigenschappenScreen.css';

const { Content, Sider } = Layout;

const menuItems = [
  { key: '1', label: <Link to="/Admin/configuratie/KlasType">Klastype</Link> },
  { key: '2', label: <Link to="/Admin/configuratie/Eenheid">Eenheid</Link> },
  { key: '3', label: <Link to="/Admin/configuratie/Locatie">Locatie</Link> },
  { key: '4', label: <Link to="/Admin/configuratie/BestelTermijn">BestelTermijn</Link> },
  { key: '5', label: <Link to="/Admin/configuratie/Allergenen">Allergenen</Link>},
  { key: '6', label: <Link to="/Admin/configuratie/Klassen">Klassen</Link>},
  { key: '7', label: <Link to="/Admin/configuratie/Leverancier">Leverancier</Link>},
  { key: '8', label: <Link to="/Admin/configuratie/Producten">Producten</Link>},
  { key: '9', label: <Link to="/Admin/configuratie/OverzichtMenu">Menu</Link>}
];

const EigenschappenScreen = () => {
  return (
    <Layout className='volledig-scherm'>
      {/* Sidebar blijft staan */}
      <Sider className='sidebar'>
        <Menu mode="inline" defaultSelectedKeys={['1']} items={menuItems} />
      </Sider>

      {/* Dynamische Content Area */}
      <Layout>
        <Content className='content'>
          <Outlet /> {/* Dit zal de juiste component tonen op basis van de route */}
        </Content>
      </Layout>
    </Layout>
  );
};

export default EigenschappenScreen;
